<template>
    <Teleport to="body">
        <div v-if="alerts.length" class="fixed top-20 right-0 p-3 space-y-2">
            <div
                v-for="alert in alerts"
                :key="alert.id"
                class=""
                role="alert"
                aria-live="assertive"
                aria-atomic="true"
            >
                <div
                    class="flex"
                    :class="{
                        'animate__animated animate__fadeInRight bg-green-50 border border-green-400  rounded-xl px-12 py-4':
                            alert.type === 'success',
                        'animate__animated animate__fadeInRight bg-yellow-50 border border-yellow-400  rounded-xl px-12 py-4':
                            alert.type === 'warning',
                        'animate__animated animate__fadeInRight bg-red-50 border border-red-400  rounded-xl px-12 py-4':
                            alert.type === 'danger',
                    }"
                >
                    <div
                        class="flex items-center justify-around space-x-2 rounded"
                    >
                        <svg
                            v-if="alert.type === 'success'"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            class="w-7 h-7 text-green-600"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
                                clip-rule="evenodd"
                            />
                        </svg>

                        <svg
                            v-if="alert.type === 'danger'"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            class="w-7 h-7 text-red-600"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z"
                                clip-rule="evenodd"
                            />
                        </svg>

                        <p
                            class="first-letter:uppercase text-sm font-medium tracking-wider"
                        >
                            {{ alert.message }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>
<script setup>
import { computed, watch } from "vue";
import { usePage } from "@inertiajs/inertia-vue3";
import useAlerts from "@/Composables/useAlerts";

const alert = computed(() => {
    return usePage().props.value.flash.alert;
});
const { addAlert, alerts } = useAlerts();
// console.log(alerts)

watch(alert, (newVal) => {
    if (newVal) {
        addAlert(newVal);
    }
});
</script>

<style></style>
